// extracted by mini-css-extract-plugin
export default {"contentblockBorder":"ContentBlockBorderDragging_contentblockBorder__xw5pW"};